import { Component, Inject } from '@angular/core';
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-edit-alias-dialog',
  template: `
    <h1 mat-dialog-title>Alias Name </h1>

    <input type="text" [(ngModel)]="alias" 
    placeholder="Please write a meaningful alias name .." 
  class="form-control mb-3 mt-2" />
    <div mat-dialog-actions>
      <button mat-button class="btn-light" [mat-dialog-close]="null">Cancel</button>
      <button mat-button class="btn-success" [mat-dialog-close]="alias" cdkFocusInitial>Continue</button>
    </div>
  `,
})
export class AddEditAliasDialogComponent {
  alias:string
  constructor(
    public dialogRef: MatDialogRef<AddEditAliasDialogComponent>,
  ) { }
}

